import React from "react";
import "./LoginPage.css";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import { useHistory } from "react-router-dom";
import { auth, provider } from "../config/firebase";
import { updateUser } from "../features/userSlice";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";

const LoginPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const signIn = (e) => {
    e.preventDefault();

    auth
      .signInWithPopup(provider)
      .then((res) => {
        dispatch(updateUser(res.user));
        history.push("/admin26");
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <div className="login">
      <div className="login__container">
        <img
          alt=""
          src="https://raw.githubusercontent.com/ashwin-magalu/next-tutorial-for-beginners/main/public/logo.png"
        />
        <h1 style={{ color: "cadetblue" }}>Sign-In to Portfolio</h1>
        <Button onClick={signIn}>
          <FingerprintIcon />
          Sign-In with Google
        </Button>
      </div>
    </div>
  );
};

export default LoginPage;
